import React, { useEffect, useRef, useState } from 'react';
import DeleteModal from '../Calendar/DeleteModal';
import ArchiveModal from "../Calendar/DeleteModal";
import { useToast } from 'src/components/Common/ReactToaster';
import { useDispatch, useSelector } from 'react-redux';
import CustomizeTable from 'src/components/Common/CustomizeTable/CustomizeTable';
import { Columns, LazyTableState } from 'src/models/components/dataTableWrapperModel';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Form, Formik } from 'formik';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import Select from 'src/components/Common/Select';
import DataTableWrapper from 'src/components/Grid/DataTableWrapper';
import { Option } from 'src/models/components/inputWrapperModel';
import FilterIcon from 'src/components/Common/CustomFilterandSortIcon/FilterIcon';
import SortIcon from 'src/components/Common/CustomFilterandSortIcon/SortIcon';
import FeatherIcon from "feather-icons-react";
import { AnimatePresence, motion } from 'framer-motion';
import { BUTTON_VARIANT } from 'src/constants/bulkActionVariant';
import ExportFile from 'src/components/Common/ExcelPdf Export/ExportFile';
import TooltipMEL from 'src/components/UI/Tooltip';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import BulkActionStatus from 'src/components/Common/BulkActionStatus/BulkActionStatus';
import { useNavigate } from 'react-router';
import { ROUTER } from 'src/constants/routes';
import ColumnAction from 'src/components/Common/ColumnAction/ColumnAction';
import { RootReducerState } from 'src/store/reducers';
import {
  clearDeclarationMessage,
  getDeclarationListLoading,
    resetDeclarationMessage,
} from 'src/store/actions';
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import { formatDateMEL, hasAdminOrEmployeeRoleHandler, saveAsExcelFile } from 'src/helpers/common_helpers';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { API } from 'src/util/api';
import { customizeTableColumns } from 'src/models/components/CustomizeTableColumns';

const declarationListConversion = (values: any[]) => {
  const modifeidValue = values.map((eachValue) => {
    let data: any = {};
    data["id"] = eachValue?.id;
    data['supplierName'] = eachValue?.supplierName ? eachValue?.supplierName : "";
    data['dcNumber'] = eachValue?.dcNumber;
    data['type'] = eachValue?.type == "R" ? "Returnable" : eachValue?.type == "NR" ? "Non Returnable" : "";
    data['notes'] = eachValue?.notes;
    data['supplierAddress'] = eachValue?.supplierAddress;
    data['supplierMobile'] = eachValue?.supplierMobile;
    data['supplierEmail'] = eachValue?.supplierEmail;
    data['supplierGSTNumber'] = eachValue?.supplierGSTNumber;
    data['isDeleted'] = eachValue?.isDeleted;
    return data;
  });
  return modifeidValue;
};


const DeclarationList = () => {



  const dcTypeTemplate = (options: ColumnFilterElementTemplateOptions) => {
    return (<>
      <Dropdown
        options={[{label:"Returnable",value:"R"},{label:"Non Returnable",value:"NR"}]}
        name="buyingCurrency"
        optionLabel="label"
        onChange={(e: DropdownChangeEvent) => {
          options.filterCallback(e.value, options.index);
          return {};
        }}
        virtualScrollerOptions={{ itemSize: 35 }}
        required={true}
        value={options.value}
        filter
        itemTemplate={(option: any) => (
          <div
            title={option.label}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {option.label}
          </div>
        )}
      />
    </>);
  };
  const columns: Columns[] = [
    // {
    //   field: "select",
    //   sortable: false,
    //   header: "",
    //   filter: false,
    //   showFilterMenu: false,
    //   selectionMode: "multiple",
    //   headerStyle: { width: "3rem", whiteSpace: "nowrap" },
    //   isDefault: true,
    //   isStatic: true,
    //   frozen: true,
    // },

    {
      field: "dcNumber",
      sortable: false,
      header: "DC Number",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      body:(rowData:any)=>actionBodyTemplate(rowData,"dcNumber"),
      isDefault: true,
      isStatic: true,
      frozen: true,
    },
    {
      field: "type",
      sortable: false,
      header: "DC Type",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      isDefault: true,
      isStatic: false,
      filterElement:dcTypeTemplate
    },
    {
      field: "supplierName",
      sortable: true,
      header: "Supplier Name",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "notes",
      sortable: false,
      header: "Notes",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "supplierAddress",
      sortable: false,
      header: "Supplier Address",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "supplierMobile",
      sortable: false,
      header: "Supplier Mobile",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "supplierEmail",
      sortable: false,
      header: "Supplier Email",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "supplierGSTNumber",
      sortable: false,
      header: "Supplier GST Number",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      isDefault: true,
      isStatic: false,
    },
   
  ];



  //filter details
  const filterDetails: DataTableFilterMeta = {
    supplierName: { value: "", matchMode: "contains" },
    dcNumber: { value: "", matchMode: "contains" },
    supplierMobile: { value: "", matchMode: "contains" },
    supplierEmail: { value: "", matchMode: "contains" },
    type: { value: "", matchMode: "contains" },
    IsDeleted: { value: "false", matchMode: "contains" },
  };

  //initial lazystate
  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    sortField: "creationDateTime",
    sortOrder: -1,
    filters: filterDetails,
  };

  const [visible, setVisible] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeclarations, setSelectedDeclarations] = useState<any>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [rowData, setRowData] = useState<any | null>(null);
  const [archiveModal, setArchiveModal] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const [showCustomizeTable, setShowCustomizeTable] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(columns.filter((eachColumn: Columns) => eachColumn.isDefault));
  const [lazyState, setLazyState] = useState(initialLazyState);
  const [filter, setFilter] = useState(false);
  const [selectedStatus, setselectedStatus] = useState("OnlyActive");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, message, loading, paginatorCount } = useSelector((state: RootReducerState) => state.DeclarationReducer);
  const {  dealerList } = useSelector((state: RootReducerState) => state.invoiceReducer);
  const { profile} = useSelector((state: RootReducerState) => state.profilesReducer);

  const [pdfLoading, setPdfLoading] = useState<boolean>(false);

  const { items, totalCount } = useSelector((state: RootReducerState) => state.DeclarationReducer.declarationList);
   



  const modifiedValues: any[] = declarationListConversion(items?.length > 0 ? items : []);

  const dt = useRef<DataTable<any>>(null);
  const initialValues = {
    status: "",
  };
  const defaultColumns = {
    ...columns[0]
  };
  
  const options: Option[] = [
    { label: "All", value: "Active" },
    { label: "Active", value: "OnlyActive" },
    { label: "Deleted", value: "Deleted" },
  ];

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading || pdfLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading, pdfLoading]);

  const bulkActionClickHandler = () => {
    if (modifiedValues.length > 0) {
      let unLocked = modifiedValues.filter((item: any) => item.locked != true && item.isDeleted != true);
      setSelectedDeclarations(unLocked);
      setSelectAll(unLocked.length == paginatorCount);
    }
  };

  const cancelBulkActionHadler = () => {
    setSelectAll(false);
    setSelectedDeclarations([]);
  };

  const customizeTableClickHandler = () => {
    setShowCustomizeTable(true);
  };

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const onCreateClickHandler = () => {
    navigate(ROUTER.DECLARATION_CREATE);
  };

  const changeColumnDetails = (values: any[]) => {

    let modifiedColumnDetails = values.map((eachValue) => {
      let data: any = {};
      data['DC Number'] = eachValue?.dcNumber;
      data['Type'] = eachValue?.type;
      data['Supplier Name'] = eachValue?.supplierName ? eachValue?.supplierName : "";
      data['Supplier Address'] = eachValue?.supplierAddress;
      data['Supplier Mobile'] = eachValue?.supplierMobile;
      data['Supplier Email'] = eachValue?.supplierEmail;
      data['Supplier GST Number'] = eachValue?.supplierGSTNumber;
      data['Notes'] = eachValue?.notes;
      return { ...data };
    });
    return modifiedColumnDetails;
  };

  const saveDataAsExcel = (values: any[], fileName: string) => {
    const modifiedColumnDetails = changeColumnDetails(values);
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(modifiedColumnDetails);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      saveAsExcelFile(excelBuffer, fileName);
    });
  };
  const fetchData = async (isPdf: boolean) => {
    let lazy: any = {
      ...lazyState,
      rows: totalCount > 5000 ? 5000 : totalCount < 1 ? 1 : totalCount,
      first: 0,
      filters: {
        ...lazyState.filters,
      },
    };

    try {
      setPdfLoading(true);
      const response = await API.getDeclarationList(lazy);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      const modifeidValue = response?.data?.items?.map((eachValue: any) => {
        let data: any = {};
        data["id"] = eachValue?.id;
        data['supplierName'] = eachValue?.supplierName ? eachValue?.supplierName : "";
        data['dcNumber'] = eachValue?.dcNumber;
        data['type'] = eachValue?.type == "R" ? "Returnable" : eachValue?.type == "NR" ? "Non Returnable" : "";
        data['notes'] = eachValue?.notes;
        data['supplierAddress'] = eachValue?.supplierAddress;
        data['supplierMobile'] = eachValue?.supplierMobile;
        data['supplierEmail'] = eachValue?.supplierEmail;
        data['supplierGSTNumber'] = eachValue?.supplierGSTNumber;
        return data;
      });
      if (isPdf) {

        saveDataAsPdf(modifeidValue, columns, "Delivery Challan");
      } else {
        saveDataAsExcel(modifeidValue, "Delivery Challan");
      }
      setPdfLoading(false);
    } catch (error: any) {
      showToast(error.message, { type: "error" });
      setPdfLoading(false);

    } finally {
      setPdfLoading(false);
    }
  };
  const csvClickHandler = () => {
    fetchData(false);
  };

  const saveDataAsPdf = (values: any[], columns: any[], fileName: string) => {
    const destructureedData = values.map((eachValue) => {
      let datas = {
        ...eachValue
      };
      return datas;
    });
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const exportColumns = columns.map((col) => ({
          title: col.header,
          dataKey: col.field,
        }));
        const doc = new (jsPDF as any).default({
          orientation: 'landscape',
          format: 'a2',
        });
        doc.autoTable(exportColumns, destructureedData);
        doc.save(`${fileName}.pdf`);
      });
    });
  };

  const pdfClickHandler = () => {
    fetchData(true);
  };

  const viewHandler = (rowData: any) => {
    navigate(`${ROUTER.DECLARATION_VIEW}/${rowData["id"]}`);
  };

  const editHandler = (rowData: any) => {
    navigate(`${ROUTER.DECLARATION_EDIT}/${rowData["id"]}`);
  };

  const deleteHandler = (rowData: any) => {
    setDeleteModal(true);
    setRowData(rowData);
  };


  const actionBodyTemplate = (rowData: any, field: string) => {
    return (
      <>
        {(( rowData.isDeleted == true)) ? <ColumnAction
          displayData={rowData[field] as string}
          isEdit={false}
          isDelete={false}
          isView={true}
          onViewClick={() => viewHandler(rowData)}
        /> : <ColumnAction
          displayData={rowData[field] as string}
          isEdit={true}
          isDelete={false}
          isView={true}
          onViewClick={() => viewHandler(rowData)}
          onEditClick={() => editHandler(rowData)}
          onDeleteClick={() => deleteHandler(rowData)}
        />}

      </>

    );
  };
  const clearFilter = () => {
    setLazyState(initialLazyState);
  };

  const header =
    <div className="table-header-container">
      <div>Delivery Challan List</div>
      <div className="table-header-container-item table-header-container-item-special">
        {/* {(selectedDeclarations.length == 0 && selectedStatus != "Active" && selectedStatus != "Locked" && selectedStatus != "Deleted" && hasAdminOrEmployeeRoleHandler()) && <Button type="button" className="customize-table-button mr-1 " onClick={bulkActionClickHandler}>
          <FeatherIcon icon="layers" className="mr-1" />
          Bulk actions
        </Button>} */}
        <AnimatePresence>
          {(selectedDeclarations.length > 0 && hasAdminOrEmployeeRoleHandler()) &&
            <>
            
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                <Button type="button" className="secondary-btn delete-space btn_space mr-1" onClick={() => { setDeleteModal(true); }}>
                  <FeatherIcon icon="trash-2" className="mr-1" />
                  <span className="remove_lables">Delete</span>
                </Button>
              </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                <Button type="button" className="customize-table-button btn_space" onClick={cancelBulkActionHadler} > <FeatherIcon icon="x" className="" /> <span className="remove_lables">Cancel selection</span></Button>
              </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                {selectedDeclarations.length > 0 && <BulkActionStatus count={selectedDeclarations.length} title="Delivery Challan"></BulkActionStatus>}
              </motion.div>
            </>
          }
        </AnimatePresence>

      </div>
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item">
        <ExportFile exportExcel={csvClickHandler} exportPdf={pdfClickHandler} clearFilter={clearFilter} isFilter={true} />
        {/* <TooltipMEL title="Select Status" position="bottom" tooltipVisible={isTooltipVisible} setTooltipVisible={setIsTooltipVisible}>
          <Dropdown value={selectedStatus} onChange={(e) => handleSubmit(e.value)} options={options} optionLabel="label" placeholder="Select status .."
            filter className="w-full md:w-14rem" />
        </TooltipMEL> */}
        <Button type="button" className="customize-table-button" id="ScheduleUpdateTooltip"
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)} data-btn="btn" onClick={customizeTableClickHandler}>
          <FeatherIcon icon="sliders" />
        </Button>
        {hasAdminOrEmployeeRoleHandler() &&
          <Button type="button" className="btn btn-primary add_btn" onClick={onCreateClickHandler}>
            <FeatherIcon icon="plus-circle" className={"feathet-icon"} />
            Add Delivery Challan
          </Button>
        }

        <UncontrolledTooltip
          placement="bottom"
          target="ScheduleUpdateTooltip"
          isOpen={tooltipOpen}
          toggle={toggleTooltip}
          innerClassName="tooltip-color"
        >
          Choose fields you want to see in the table
        </UncontrolledTooltip>
        
      </div>

    </div>;

  //hide error dialog tab
  const hidePopup = () => {
    setVisible(false);
    dispatch(resetDeclarationMessage());
  };

  //error dialog
  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };


  //delete declarationpage
  const handleDeleteDeclaration = (rowData: any, length: number = 0, index: number = 0) => {
    let payload = {
      id: rowData["id"] ? rowData["id"] : rowData[0]?.id,
      lazyState,
    };
    // dispatch(declarationDeleteLoading(payload));
    setDeleteModal(false);
    setRowData(null);
    if (index + 1 === length || index === length) {
      // setTimeout(() => {
      // dispatch(getFranchiseeListLoading(lazyState));
      // }, 500);
      setSelectAll(false);
      // showToast("Declarations Deleted Successfully", { type: "success" });
      setSelectedDeclarations([]);
    }
  };

  //deleteModal action
  const deleteModalClick = () => {

    if (selectedDeclarations?.length > 10) {
      showToast("Cannot delete more than 10 items at once", { type: "error" });
      setSelectedDeclarations([]);
      setDeleteModal(false);
      setSelectAll(false);
      return setRowData(null);
    }

    if (rowData || selectedDeclarations.length == 1) {
      handleDeleteDeclaration(rowData || selectedDeclarations);
    } else if (selectedDeclarations.length > 1) {
      for (let i = 0; i < selectedDeclarations.length; i++) {
        handleDeleteDeclaration(selectedDeclarations[i], selectedDeclarations.length, i);
      }
    }
  };

  //archive handler
  const archiveHandler = () => {
    setSelectAll(false);
    setSelectedDeclarations([]);
    setArchiveModal(false);
  };

  //customize table action

  const customizeTableCancelHandler = () => {
    setShowCustomizeTable(false);
  };

  const customizeColumnSubmitHandler = (customizeColumnObject: any[]) => {
    let orderedSelectedColumns = columns.filter((col) => customizeColumnObject.some((sCol: any) => sCol === col.field));

    setVisibleColumns([ ...orderedSelectedColumns]);
    setShowCustomizeTable(false);
  };

  const customizeTableColumns: customizeTableColumns[] = columns.map((eachColumns: Columns) => {
    let data: any = {};
    data['field'] = eachColumns.field;
    data['value'] = visibleColumns.some((sCol: any) => sCol.field === eachColumns.field);
    data['isDisable'] = eachColumns.isStatic;
    data['header'] = eachColumns.header;
    return data;
  }).filter((eachColumns: customizeTableColumns) => eachColumns.field != 'select');


  const handleSubmit = (formValue: any) => {
    setselectedStatus(formValue);

   
    setIsTooltipVisible(false);
  };

  const handleReset = (formValue: any) => {
    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,
          value: "",
        }
      },
    }));
  };

  const onSelectionChange = (event: any) => {
    const value = event.value;
    if(hasAdminOrEmployeeRoleHandler() && profile?.extraProperties?.IsSuperAdmin==true){
      let unLocked = value.filter((item: any) => (item.locked != true && item.isDeleted != true));
      setSelectedDeclarations(unLocked);
      setSelectAll(unLocked.length == paginatorCount);
    }
  };

  const onSelectAllChange = (event: any) => {
    const selectAll = event.checked;
    if (selectAll && (hasAdminOrEmployeeRoleHandler() && profile?.extraProperties?.IsSuperAdmin==true)) {
      let unLocked = modifiedValues.filter((item: any) => item.locked != true && item.isDeleted != true);
      setSelectedDeclarations(unLocked);
      setSelectAll(unLocked.length == paginatorCount);
    } else {
      setSelectAll(false);
      setSelectedDeclarations([]);
    }
  };


  const onSort = (event: any) => {
    setLazyState(event);
    setSelectedDeclarations([]);
    setSelectAll(false);
  };

  const onFilter = (event: any) => {
    event["first"] = 0;
    setLazyState(event);
  };

  const onPage = (event: any) => {
    setLazyState(event);
  };

  const callbackFunction = (lazyState: LazyTableState) => {
    dispatch(getDeclarationListLoading(lazyState));
  };

  useEffect(() => {
    setSelectAll(false);
    setSelectedDeclarations([]);
    callbackFunction(lazyState);
  }, [lazyState]);

  useEffect(() => {
    setVisibleColumns(columns.filter((eachColumn: Columns) => eachColumn.isDefault));
  }, [ dealerList,profile]);

  useEffect(() => {
    if (error) {
      setVisible(true);
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(clearDeclarationMessage());
      dispatch(getDeclarationListLoading(lazyState));
    }
  }, [error, message]);


  return (
    <React.Fragment>
      <div className="page-content">
        {visible && dialogContainer(error)}
        <DeleteModal
          show={deleteModal}
          onDeleteClick={deleteModalClick}
          onCloseClick={() => {
            setDeleteModal(false);
            setRowData(null);
          }}
        />
        <ArchiveModal
          show={archiveModal}
          message="you want to archieve these administrators?"
          deleteLabel="Yes"
          closeLabel="No"
          onDeleteClick={() => {
            archiveHandler();
          }}
          onCloseClick={() => {
            setArchiveModal(false);
            setSelectAll(false);
            setSelectedDeclarations([]);
          }}
        />

        {showCustomizeTable && <CustomizeTable onCancelHandler={customizeTableCancelHandler} onCustomizeColumnSubmitHandler={customizeColumnSubmitHandler} columns={customizeTableColumns} />}


        {filter && (
          <div className="card">
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                onReset={handleReset}
                enableReinitialize
              >
                {({ values, handleChange }) => {
                  return (
                    <Form onChange={handleChange}>
                      <Row>
                        <Col xs={12} lg={7} id="export-search-clear">

                        </Col>
                        <Col xs={12} lg={5} id="export-search-clear d-flex">
                          <Select
                            label=""
                            name="status"
                            value={values.status}
                            onChange={handleChange}
                            options={options}
                            invalid={false}
                          />
                          <Button className="btn btn-primary ms-2" color="primary" type="reset">
                            Clear </Button>
                          <Button className="btn btn-primary ms-2" color="primary" type="submit">
                            Search </Button>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        )}
        <DataTableWrapper
          ref={dt}
          columnDetails={((selectedStatus == "Active" || selectedStatus == "Deleted" || selectedStatus == "Locked") || !hasAdminOrEmployeeRoleHandler()) ? [...visibleColumns]?.filter((items: any) => items.field != "select") : visibleColumns}
          header={header}
          filterIcon={FilterIcon}
          sortIcon={(setOrder) => <SortIcon order={setOrder} />}
          value={modifiedValues}
          lazy
          paginator={true}
          stripedRows={true}
          rowHover={true}
          // filterDisplay="row"
          rowsPerPageOptions={[5, 10, 25, 50]}
          totalRecords={totalCount}
          loading={loading}
          emptyMessage="No Delivery Challan found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Displaying Delivery Challan  {last} records of {totalRecords} in total"
          selection={selectedDeclarations}
          onSelectionChange={onSelectionChange}
          selectAll={selectAll}
          onSelectAllChange={onSelectAllChange}
          first={lazyState.first}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onFilter={onFilter}
          filters={lazyState.filters}
          onPage={onPage}
          rows={lazyState.rows}
        ></DataTableWrapper>
      </div>
    </React.Fragment>
  );
};

export default DeclarationList;